/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInMessageStepMessageDoc } from './linkedInMessageStepMessageDoc';
import type { LinkedInMessageStepPriority } from './linkedInMessageStepPriority';
import type { LinkedInMessageStepTaskNoteDoc } from './linkedInMessageStepTaskNoteDoc';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface LinkedInMessageStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: LinkedInMessageStepPriority;
  type: 'linkedin_message';
  message_doc: LinkedInMessageStepMessageDoc;
  include_sender_signature?: boolean;
  task_note_doc?: LinkedInMessageStepTaskNoteDoc;
}
